<div class="controls" *ngIf="!disableControls()">
  <button class="login" (click)="showSelectingLoginTypeModal()">Log in</button>
</div>
<app-select-login-type-modal
  [loginTypes]="loginTypes"
  (onLoginTypeSelected)="setLoginType($event)"
  [show]="selectingLoginType()"
  (onClose)="hideSelectingLoginTypeModal()"
></app-select-login-type-modal>
